import React from 'react';
import styled from 'styled-components';

import CycleCard from './CycleCard';

import { themes } from 'kb-shared';

import { Package } from 'kb-shared';
import { CycleType, Cycle } from '../types';

const { breakpoints } = themes;

const CardRow = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: center;
  width: 100%;

  @media (max-width: ${breakpoints.largePhonePortrait}) {
    flex-direction: column;
  }
`;

type Props = {
  onSelect: (selection: Cycle) => void;
  cycles: Array<Package>;
  selected?: Package;
  selectedCycleType: CycleType;
};

const CyclesRow = (props: Props) => {
  const { cycles, onSelect, selectedCycleType, selected } = props;

  return (
    <CardRow>
      {cycles.map(cycle => (
        <CycleCard
          key={`cycle-card-${cycle.id}`}
          cycle={cycle}
          onSelect={cycle => {
            onSelect(cycle);
          }}
          selected={selected !== undefined && selected.id === cycle.id}
          selectedCycleType={selectedCycleType}
        />
      ))}
    </CardRow>
  );
};

export default CyclesRow;
